import React from 'react';

import {
  CaseBenefitsTabContent,
  CASE_BENEFIT_EM_TAG_CLOSE,
  CASE_BENEFIT_EM_TAG_OPEN,
  CASE_BENEFIT_SPECIAL_SPACE_CHARACTER,
} from '../case-benefits-tab-content';

const EM_TAG_OPEN = CASE_BENEFIT_EM_TAG_OPEN;
const EM_TAG_CLOSE = CASE_BENEFIT_EM_TAG_CLOSE;
const SPECIAL_SPACE_CHARACTER = CASE_BENEFIT_SPECIAL_SPACE_CHARACTER;

export const Case1BenefitsTabContent = React.memo(() => {
  const Case1Benefits = React.useMemo<string[]>(() => {
    const case1Benefits: string[] = [
      `Complete ${EM_TAG_OPEN}AI-powered${EM_TAG_CLOSE} closed-loop optimization process`,
      `${EM_TAG_OPEN}40%${SPECIAL_SPACE_CHARACTER}reduction${EM_TAG_CLOSE} in degraded sites using AI-based Cognitive Diagnostics`,
      `${EM_TAG_OPEN}Tangible${SPECIAL_SPACE_CHARACTER}OPEX${EM_TAG_CLOSE} savings on analysis & optimization efforts`,
      `${EM_TAG_OPEN}Revenue${SPECIAL_SPACE_CHARACTER}protection,${EM_TAG_CLOSE} based on churn reduction and performance increase`,
    ];

    return case1Benefits;
  }, []);

  return <CaseBenefitsTabContent items={Case1Benefits} />;
});
